// const [deviceFormData, setDeviceFormData] = React.useState({
//     brand: "",
//     company: "",
//     dataProtocol: "",
//     description: "",
//     id: "",
//     model: "",
//     password: "",
//     software: "",
//     softwareVersion: "",
//     status: "ACTIVE",
// });

export const product_fields = () => [
  {
    key: 'productName',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Ürün Adı*',
    defaultValue: '',
  },
  {
    key: 'status',
    type: 'select',
    items: [
      { value: 'ACTIVE', text: 'Aktif' },
      { value: 'INACTIVE', text: 'Pasif' },
    ],
    placeHolder: 'Durum*',
    defaultValue: 'ACTIVE',
  },
  {
    key: 'productType',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Ürün Tipi',
    defaultValue: '',
  },
  {
    key: 'barcodeNumber',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Barkod Numarası',
    defaultValue: '',
  },
  {
    key: 'description',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Açıklama',
    defaultValue: '',
  },

  // {
  //   key: 'brand',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Marka',
  //   defaultValue: '',
  // },
  // {
  //   key: 'company',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Şirket',
  //   defaultValue: '',
  // },
  // {
  //   key: 'description',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Açıklama',
  //   defaultValue: '',
  // },
  // {
  //   key: 'model',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Model',
  //   defaultValue: '',
  // },
  // {
  //   key: 'password',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Şifre',
  //   defaultValue: '',
  // },
  // {
  //   key: 'software',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Yazılım',
  //   defaultValue: '',
  // },
  // {
  //   key: 'softwareVersion',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Yazılım Versiyonu',
  //   defaultValue: '',
  // },
];
